import Kontakt from 'src/pages/Kontakt/Kontakt'
import { getSitePageBuilderStaticProps } from 'src/pageBuilder/sitePageBuilder'

export default Kontakt

export const getStaticProps = getSitePageBuilderStaticProps
